module.exports = __webpack_public_path__ + "img/format.b8041d2b.svg";